// extracted by mini-css-extract-plugin
export default {"cls1":"Cta-cls1__nl","cls2":"Cta-cls2_IPK Cta-cls1__nl"};